import type { ReactNode } from 'react';

import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const SIDE_BAR_WIDTH = '256px';

const StyledSideBarWrapper = styled.nav`
  width: ${SIDE_BAR_WIDTH};
  max-width: ${SIDE_BAR_WIDTH};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const SideBarChildren = styled.ul`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  list-style-type: none;

  gap: ${tokens.spacer.x0pt5};

  /* Make the scrollbar appear in the padding area and allow focus outline to overflow */
  padding: ${tokens.spacer.x1pt5};
  margin: -${tokens.spacer.x1pt5};
`;

export interface SideBarProps {
  children: ReactNode;
}

export const SideBar = ({ children }: SideBarProps): JSX.Element => {
  return (
    <StyledSideBarWrapper>
      <SideBarChildren>{children}</SideBarChildren>
    </StyledSideBarWrapper>
  );
};

export interface SurveyTemplateCategoriesSideBarStatelessProps {
  onCategoryChanged: (category: string) => void;
}
